import { CoSell } from 'src/Models/CoSell';

export const MANAGE_ACTION_API_CONSTANTS = {
  GetAction: '/api/getAction',
  SearchRelatedActionItem: '/api/V2/Actions/searchRelatedActionItems',
  SearchRelatedActionItemWithAreaPath: '/api/Actions/searchRelatedActionItemsWithAreaPath',
  GetRelatedWorkItems: '/api/Actions/getRelatedWorkItems',
  SearchRemoteWorkItemsList: '/api/Actions/getRemoteLinks',
  SearchRemoteWorkItem: '/api/Actions/getRemoteLink',
  UpdateAction: '/api/updateAction',
  UpdateDWRRequest: '/api/updateDWRRequest',
  GetWorkItemHistory: '/api/getWorkItemHistory',
  followActionRoot: '/api/v1/raid/transactional/raiditem',
  GetFollowing: 'followactions',
  AddFollowing: `follow`,
  DeleteFollowing: 'unfollow',
  GetRelatedFeedbackItems: '/api/getRelatedFeedbackItems',
  uploadAttachments: '/api/UploadFile',
  GetWorkItemComments: '/api/getWorkItemComments',
  GetADOTags: '/api/getADOTags',
  PostWorkItemComment: '/api/postWorkItemComment',
  UpdateWorkItemComment: '/api/updateWorkItemComment',
  DeleteWorkItemComment: '/api/deleteWorkItemComment',
  getEmail: '/api/GetEmails',
  PartnerRegionAreaFromCountry: '/api/partnerRegionAreaFromCountry',
  GetPartnerEngagementByReferralID: 'api/V2/MSX/GetPartnerEngagementByReferralID?referralId=',
  GetCustomerByTPID: 'api/V2/MSX/GetByCustomer?TPID=',
  GetByOpportunity: 'api/V2/MSX/GetByOpportunity?opportunityId=',
  GetRaidEntity: '/api/v1/raid/transactional/raiditems',
  UpdateRaidEntity: '/api/v1/raid/transactional/raiditems/update',
  GetComments: '/api/v1/raid/transactional/comments',
  GetGroupMembers: '/api/groupMembers',
  UpdateComment: '/api/v1/raid/transactional/comments/update',
  CreateComment: '/api/v1/raid/transactional/comments/create',
  DeleteComment: '/api/v1/raid/transactional/comments/delete',
  UploadArtemisAttachments: '/api/v1/raid/transactional/UploadFile',
  GetUploadSasUrl: '/api/v1/raid/transactional/GetUploadSasUrl',
  GetDownloadSasUrl: '/api/v1/raid/transactional/GetDownloadSasUrl',
  DownloadArtemisAttachments: '/api/v1/raid/transactional/downloadAttachmentFile',
  GetAreaPaths: 'api/areaPaths',
  GetAMMMilestoneSnapshot: 'api/V2/MSX/GetAMMMilestoneSnapshot?actionId=',
  AONAcrAndRoiDetails: 'api/v1/raid/transactional/ammaon/totalacrfromaon',
  GetPartnerList: 'api/V2/Actions/getPartnerList?ActionId=',
  GetControlList: 'api/V2/Actions/getControlList?ActionId=',
  SaveControlList: '/api/V2/Actions/saveUpdateControlList?ActionId=',
  GetTaskList: 'api/V2/Actions/getTaskList?ActionId=',
  GetUsersTable: '/api/usersTable',
  GetUsersAndGroups: '/api/usersAndGroups',
  GetPartnerOneInfo: 'api/V2/Actions/getpartnerOneinfo?searchTerm=',
  SavePartnerList: 'api/V2/Actions/saveUpdatePartnerList',
  GetTaskInfo: '/api/V2/Actions/getTaskList',
  SaveTaskList: '/api/V2/Actions/saveUpdateTaskList',
  GetRaidHistory: '/api/v1/raid/transactional/raidhistory',
  GetArtemisTags: '/api/v1/raid/transactional/tags',
  AdoBasedOnArtemis: '/api/v1/raid/transactional/raiditems',
  ArtemisBasedOnAdo: '/api/v1/raid/transactional/raiditems',
  GetMSXInfoByMSSalesID: 'api/v1/MSXData/MSXInfoByMSSalesId',
  CopilotReWrite: '/api/v1/GPTTurnKey/Rewrite',
  GetByOpportunityWithMilestones: '/api/V2/MSX/GetByOpportunityWithMilestones?opportunityId=',
  GetDeDupOpportunities: 'api/V2/MSX/GetDeDupOpportunities',
  GetWorkScopes: '/api/ECIFWorkscope/GetWorkscopes?opportunityId=',
  GetWorkItemDetails: '/api/ECIFWorkscope/GetWorkscopedetails/',
  GetByOpportunityWithEcifAcrRoiCalculations:
    '/api/V2/MSX/GetByOpportunityWithEcifAcrRoiCalculations?opportunityId=',
  GetActionOwnerForAreaEOU: 'api/V2/Actions/getActionOwnerForAreaEOU',
  GetIsRestrictedUser: '/api/v1/raid/transactional/usermetadata/checkusercountry/',
  GetValidationAutomation: 'api/v1/raid/transactional/fieldvalidation',
  GetIsRestrictedUserForPIIFields:
    '/api/v1/raid/transactional/usermetadata/checkusercountryforPIIFields',
  AddAndUpdateValidationMessage: 'api/v1/raid/transactional/ammautomation/update',
  GetMileStoneDetails: '/api/V2/MSX/GetByMilestone?milestoneId=',
  GetWorkloads: '/api/v1/raid/transactional/getworkloads',
  GetRecommendedOffers: '/api/v1/raid/transactional/getrecommendedoffers',
  GetUniqueTPIDs: '/api/v1/raid/transactional/raiditems/checktpids?tenantid=',
  ValidateSRNumbers: '/api/V2/Actions/validatesrnumbers',
};

export const MANAGE_ACTION_CONSTANTS = {
  JWT_TOKEN_FOR_API: 'jwtTokenForApi',
  JWT_TOKEN_FOR_CORE_API: 'jwtTokenForCoreApi',
  JWT_TOKEN_FOR_GRAPH: 'jwtTokenForGraph',
  QUERYID: 'e07db7d1-0e25-4c9d-9c73-4e12c8b2fc7w',
};

export const HISTORY_TAB_CONSTANTS = {
  MovedToState: 'Moved to state',
  UserProfile: 'User Profile',
  ActionStatus: 'Item Status',
  TriageOwnersInfo: 'triageOwnersinfo',
};

export const StateColors: any[] = [
  { key: 'In Progress', bgColor: '#2886DE' },
  { key: 'In-Progress', bgColor: '#2886DE' },
  { key: 'Done', bgColor: '#107C10' },
  { key: 'Escalated', bgColor: '#FDE8EA' },
  { key: 'New', bgColor: '#7160E8' },
  { key: 'Removed', bgColor: '#BBBBBB' },
  { key: 'On Hold', bgColor: '#D77F00' },
  { key: 'Design', bgColor: 'rgb(10, 112, 181)' },
  { key: 'In Technical Feedback', bgColor: '#1AEBFF' },
  { key: 'Rejected', bgColor: '#D13438' },
  { key: 'Cancelled', bgColor: '#6E0811' },
  { key: 'Completed', bgColor: '#00CC6A' },
  { key: 'Open', bgColor: 'rgb(184, 124, 230)' },
  { key: 'Closed', bgColor: '#EEACB2' },
  { key: 'Pending', bgColor: '#605E5C' },
  { key: 'Draft', bgColor: '#EAA301' },
  { key: 'Activating Offer', bgColor: '#0027B4' },
  { key: 'Offer Activated', bgColor: '#01666D' },
  { key: 'Project Complete', bgColor: '#00CC6A' },
  { key: 'Not Started', bgColor: '#605E5C' },
  { key: 'On Track', bgColor: '#2886DE' },
  { key: 'At Risk or Blocked', bgColor: '#D13438' },
  { key: 'Default', bgColor: '#5C5C5C' },
];

export const PlaceholdersAndTitles = {
  GPSDeleteControlItem: 'Delete Control',
};

export const ACTION_FOLLOW_MESSAGES = {
  SuccessMessages: {
    AddSubscriptiontoWokrItemMessages: `You are now following this Action.`,
    DeleteSubscriptiontoWokrItemMessages: `You are no longer following this Action.`,
  },
};

export enum AccordionType {
  BasicDetails,
  OpportunityDetails,
  RequestDetails,
  PartnerDetails,
  DealDetails,
  AOAIBasicDetail,
  AOAIAccounts,
  AOAIOpportunity,
  AOAIMilestone,
  AOAIRequestedCapacity,
  AOAIApprovedCapacity,
  BusinessProcess,
  BasicInformation,
  CaseDetails,
  PIR,
  MultiPartnerInvestment,
  CELAInformation,
  ComplianceInformation,
  OperationsInformation,
  FinancialInformation,
  StrategyInformation,
  CorpAccountInformation,
  OngoingMonitoring,
  Policy,
  Documentation,
  SurveyQuestions,
}

export const DETAILS_TAB_CONSTANTS = {
  BasicDetails: 'Details',
  DeliveryOption: 'Delivery option',
  Opportunity: 'Opportunity',
  Account: 'Account',
  AOAIRequest: 'AOAI requested capacity',
  Milestone: 'Milestone',
  AOAIreqCapacity: 'AOAI requested capacity',
  AOAIapprovedCapacity: 'AOAI approved capacity',
};

export const COSELL_TAB_CONSTANTS = {
  Details: 'Details',
  Related: 'Related',
  Attachments: 'Attachments',
  History: 'History',
  NBAR: 'NBAR',
};

export const COSELL_LEFT_TAB_CONSTANTS = [
  {
    label: 'Basic Information',
    id: AccordionType.BasicDetails,
  },
  {
    label: 'Opportunity Details',
    id: AccordionType.OpportunityDetails,
  },
  {
    label: 'Deal Details',
    id: AccordionType.DealDetails,
  },
];

export const GPS_TAB_CONSTANTS = [
  {
    label: 'Business Process',
    id: AccordionType.BusinessProcess,
  },
  {
    label: 'Basic Information',
    id: AccordionType.BasicInformation,
  },
  {
    label: 'Case Details',
    id: AccordionType.CaseDetails,
  },
  {
    label: 'Partner Investments Review',
    id: AccordionType.PIR,
  },
  {
    label: 'Financial Information',
    id: AccordionType.FinancialInformation,
  },
  {
    label: 'Strategy Information',
    id: AccordionType.StrategyInformation,
  },
  {
    label: 'Operations Information',
    id: AccordionType.OperationsInformation,
  },
  {
    label: 'Corp Accounting Information',
    id: AccordionType.CorpAccountInformation,
  },
  {
    label: 'CELA Information',
    id: AccordionType.CELAInformation,
  },
  {
    label: 'Compliance Information',
    id: AccordionType.ComplianceInformation,
  },
  {
    label: 'Monitoring, Risk and Issues',
    id: AccordionType.OngoingMonitoring,
  },
  {
    label: 'Multi Partner Investment',
    id: AccordionType.MultiPartnerInvestment,
  },
  {
    label: 'Policy',
    id: AccordionType.Policy,
  },
  {
    label: 'Documentation',
    id: AccordionType.Documentation,
  },
];

export const CONTROL_LIST_HEADER = [
  'Control ID',
  'Control Type',
  'Owner Name',
  'Start Date',
  'Actions',
];

export const COSELL_RIGHT_TAB_CONSTANTS = [
  {
    label: 'Request Details',
    id: AccordionType.RequestDetails,
  },
  {
    label: 'Partner Details',
    id: AccordionType.PartnerDetails,
  },
];

export const AOAI_TAB_CONSTANTS = [
  {
    label: 'Basic Details',
    id: AccordionType.AOAIBasicDetail,
  },
  {
    label: 'Account Information',
    id: AccordionType.AOAIAccounts,
  },
  {
    label: 'Opportunity Information',
    id: AccordionType.AOAIOpportunity,
  },
  {
    label: 'Milestone Information',
    id: AccordionType.AOAIMilestone,
  },
  {
    label: 'AOAI Requested Capacity',
    id: AccordionType.AOAIRequestedCapacity,
  },
  {
    label: 'AOAI Approved Capacity',
    id: AccordionType.AOAIApprovedCapacity,
  },
];

export const PROJECT_CONSTANTS = {
  Project: (import.meta as any).env.VITE_PROJECT || 'Unified Action Tracker Test',
};

export const MANAGE_ACTION_HEADER_CONSTANTS = {
  Follow: 'Follow',
  Following: 'Following',
  EditInADO: 'Edit in ADO',
  SendEmailLabel: 'Email',
  CopyLink: 'Copy Link',
  CreateCAPERequest: 'Create CAPE Request',
  Capelogosvg: 'capelogosvg',
  jwtUserAccountEmail: 'jwtUserAccountEmail',
  LinkClipboard: 'Link copied to clipboard',
  IsProduction: PROJECT_CONSTANTS.Project === 'Unified Action Tracker',
  AddTag: 'Add Tag',
  Select: 'Select',
  RunValidationCheck: 'Run Validation Check',
};

export const MANAGE_ACTION_FIELDS = {
  NodeName: 'System.NodeName',
  CoSell: 'CoSell',
  RoB: '6f76ed48-1b55-4951-920a-90b995e4d5cc',
  Hub: 'Hub',
  GPS: 'Partner Investments',
  PMYT: 'Partner Marketing Yield Tracker',
  CAPSL: 'dd373c03-794c-4500-b944-62fe9698de56',
  SGS: 'SGS',
  GSI: 'GSI ACO PIR',
  RedButtonTSI: 'Red Button TSI',
  SMCRedButton: 'SMC Red Button',
  McapsHelpPMNode: 'MCAPS Help PM',
  CapslNode: 'CAPSL',
  McapsMacc: 'MACC Exception',
  MaccSupport: 'MACC Unified Purple Empowerment',
  MdcSupport: 'MDC Attach Purple Exception',
  RoBTenantId: '6f76ed48-1b55-4951-920a-90b995e4d5cc',
  RoBStateKeyName: 'displayName',
  GPSTenantId: '4b9ac222-75ab-4566-a4e4-c9553896f290',
  PMYTTenantId: 'af315f0d-0028-49ed-b197-1aaf897d56c8',
  CAPSLTenantId: 'dd373c03-794c-4500-b944-62fe9698de56',
  USMaaSTenantID: 'ca7c5a04-59de-48f1-b6b7-48c3acc5dac5',
  GSITenantId: 'd5a5c2d1-b8be-4b18-a4c3-6d09e5f0c59c',
  MaccSupportTenantId: '6f76ed48-1b55-4951-920a-90b995e4d5dd',
  RedButtonTSITenantId: 'b878ed1d-5d4c-4a64-9716-221f9484f381',
  SMCRedButtonTenantId: 'b878ed1d-5d4c-4a64-9716-221f9484f381',
  McapsHelpPMTenantId: '1762e166-b734-43de-a37d-63aadd76becc',
  SGSTenantId: '5461fe99-0356-49d5-be95-63cbbe8a187a',
  ECIFTenantId: '17a19c34-f60e-465f-af34-fa82b61cb9b9',
  MarketplaceTenantId: 'f9e0f41d-707c-46af-b24b-626dc68601ce',
  AOAICapacity: 'AOAI Capacity',
  AzureISVTenantId: 'af315f0d-0028-49ed-b197-1bbf897d56c8',
  MSFedTenantId: 'bdbf05d2-ea1a-4d40-952f-41cd5d9bb8d6',
  NonAICapacityTenantId: '2b6b4852-8108-4aef-afca-d951b9fade7c',
  PartnerSkillingTenantId: '7e4d3c2b-1a9f-4e8d-9c6b-5a4f3e2d1c0b',
  MEATenantId: '3f9c2a7e-6b4a-4f8a-9e7d-1c5b6a8e42d9',
  MSRTenantId: 'd6d337f6-2ff5-4d52-9a74-5d9dad09164b',
};
// Generated by GitHub Copilot | Updated on: 2026-07-01 | 1 lines modified | Added MSRTenantId for Microsoft Security Research tenant

export const ATTACHMENTS_TAB_CONSTANTS = {
  AreaPath: 'System.AreaPath',
  DeleteAttachment: 'Delete attachment(s)',
  closeButtonAriaLabel: 'Close',
  subText: 'Are you sure you want to delete the attachment?',
  Max5MBFileSizeError: 'Max file size cannot be more than 5 MB',
  errorMessage: 'Max file size cannot be more than 80 MB',
  maxfileSizeErrorMessage: 'Max file size cannot be more than 50 MB',
  errorMessageFileType:
    'File Upload failed. Note that Office, Text, Email, PDF, Image, Microsoft Project, Compressed files are only allowed.',
  errorApi: 'Error while uploading File. Try again.',
  loadingText: 'Loading',
  fetching: 'Fetching',
  createAttachUrl: 'Generating url',
  uploadingFile: 'Uploading File',
  fileSelect: 'Select File',
};

export const SUGGESTION = {
  suggestionsHeaderText: 'Suggested People',
  noResultsFoundText: 'No results found',
  loadingText: 'Loading',
};

export const SuccessMessages = {
  ActionUpdatedSuccessfully: ' Action updated successfully',
  FileUploadedSuccessfully: '<strong>File Uploaded</strong>  Your file uploaded successfully',
};

export const ApprovalLabels = {
  ApprovalType: 'Approval Type',
  DocumentName: 'Document Name',
  Name: 'Name',
  Status: 'Status',
  UploadedDate: 'Uploaded Date',
  ApprovedDate: 'Approved Date',
  Actions: 'Actions',
  Upload: 'Upload',
  Delete: 'Delete',
  UploadedApprovals: 'Uploaded Approvals',
};

export const ErrorMessages = {
  //Save button error
  FormMandateError: 'Please fill all mandatory fields',
  CommonErrorStateForApi: 'Something went wrong!',
};

export const DWRSuccessMessage = {
  DWRUpdatedSuccessfully:
    'Changes saved successfully. Your changes have been saved, and the request have been created in the DWR Tracker portal',
};

export const DWRErrorMessage = {
  DWRErrorReason: `Request Error: There is an error creating a DWR request, you can try again to create the request.`,
};

export const WarningMessages = {
  leavingSiteMessage: 'Are you sure you want to leave?',
  dataChangedMessage: 'You have unsaved changes. Are you sure you want to leave?',
};

export enum UpdateActionApiStatus {
  None,
  Success,
  Error,
}

export enum HttpStatusCode {
  ok = 200,
  internalServerError = 500,
  conflict = 409,
  BadRequest = 400,
}

export enum EditCommentUseCase {
  insideManageAction,
  insideDrawer,
}

export const panelConfigs = {
  maxHeight: '88.4vh',
  closeButtonAriaLabel: 'Close',
};

export const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;

export const ManageActionRatingContext = {
  ManageActionLabel: 'Manage Action',
};

// Partner Co-Marketing Tab Constants

export const TAB_HEADINGS_CONSTANTS = {
  RELATED: 'Related',
  ATTACHMENTS: 'Attachments',
  HISTORY: 'History',
  DETAILS: 'Details',
  COSELL_DETAILS: 'Cosell Request Details',
  PARTNER_MARKETING_YIELD_TRACKER_DETAILS: 'Partner Marketing Yield Tracker',
};

export const PMYTTabConstants = [
  {
    label: 'Basic Details',
    id: AccordionType.BasicDetails,
  },
];

export const PMYT_RIGHT_TAB_CONSTANTS = [
  {
    label: 'Request Details',
    id: AccordionType.RequestDetails,
  },
];

export const GPSErrorMessages = {
  OngoingMonitoring: {
    ControlStateError: 'State is Mandatory',
    ControlCategoryError: 'Category is Mandatory',
    ControlTypeError: 'Type is Mandatory',
    DPSControlTypeError: 'Control Type is Mandatory',
    ControlOwnerNameError: 'Control Owner Name is Mandatory',
    AcceptedByError: 'Accepted By is Mandatory',
    DocumentationError: 'Documentation is Mandatory',
    ControlActivitiesDocumentationError: 'Control Activities documentation is Mandatory',
    ControlActivityError: 'Control Activity is Mandatory',
    ControlFrequencyError: 'Control Frequency is Mandatory',
    ControlStartDateError: 'Control Start Date is Mandatory',
    ControlEndDateError: 'Control End Date is Mandatory',
    ControlEndDateNotLessThanStartDate:
      'Control End Date should be greater than Control Start Date',
  },
};

export const GPSFields = {
  CELAINFORMATION: {
    review: 'CELA Review',
    stackHolderName: 'CELA PIR Stack Holder Name',
    notes: 'CELA Next Steps, Exceptions, Notes',
  },
  OPERATIONINFORMATION: {
    review: 'Operations Approval',
    stackHolderName: 'Operations PIR Stakeholder Name',
    notes: 'Operations Next Steps, Exceptions, Notes',
  },
  Requestor: 'Requestor',
  RequestorPlaceHolder: 'Search Requestor contact',
  RequestType: 'Request Type',
  RequestReason: 'Request Reason',
  GPSRequestReasonTooltip: 'Select the reason this request.',
  selectRequestType: 'Select Request Type',
  SelectRequestReason: 'Select Request Reason',
  SelectBusinessType: 'Select Business Type',
  GPSReviewDateMandatory: 'Review Date is mandatory',
  GPSDecisionMandatory: 'Decision is mandatory',
  BusinessType: 'Business Type',
  PartnerType: 'Partner Type',
  AskType: 'Ask Type',
  CustomerSegment: 'Customer Segment',
  PartnerName: 'Partner Name',
  PartnerOneId: 'Partner One Id',
  Area: 'Area',
  SolutionArea: 'Solution Area',
  Description: 'Investment Description',
  FinancialEconomics: 'Financial Economics',
  StartDate: ' Investment Start Date (UTC)',
  EndDate: 'Investment End Date (UTC)',
  InvestmentType: 'Investment Type',
  EngagementType: 'Engagement Type',
  PayoutType: 'Payout Type',
  InvestmentAmount: 'Investment Amount (USD)',
  OpportunityID: 'Opportunity ID',
  MCEMStage: 'MCEM Stage',
  MigratedDate: 'Migrated Date (UTC)',
  InvestmentComplexity: 'Investment Complexity',
  StrategyLead: 'Strategy Lead',
  EscalationDate: 'Escalation Date (UTC)',
  ExecutionPath: 'Execution Path/Qubit ID',
  ContractSignDate: 'Contract Sign Date (UTC)',
  RemoveRequestor: 'Remove Requestor',
  RemoveStrategyLead: 'Remove Strategy Lead',
  Product: 'Product',
  GPSPIRDecisionDate: 'PIR Decision Date',
  GPSPIRCaseID: 'PIR Case ID',
  GPSPIRManager: 'PIR Manager',
  GPSDPSPIRManager: 'PIR Manager/Design Lead',
  GPSPIRDecision: 'Decision',
  GPSPIRReviewDate: 'LT Review Date (UTC)',
  GPSDPSPIRReviewDate: 'Review Date (UTC)',
  GPSPIRReviewDatePlaceholder: 'Select LT Review Date',
  GPSPIRManagerNextStepsExceptionNotes: 'PIR Manager/Design Lead Next Steps, Exception, Notes',
  GPSPIRReviewDateInfo: 'Investment Feasibility [Strategy and Finance alignment] completed.',
  Documentation: {
    GPSCommercial: 'Commercial Governance Framework',
    GPSDPS: 'DPS Governance Framework',
    GPSBusinessTemplate: 'View Business case template',
    GPSFinancialModel: 'View Financial Model template',
    GPSBusinessCaseLabel: 'Business Case ',
    GPSFinancialModelLabel: 'Financial Model ',
    FindStepForModel: 'Please find steps to attach Business Case and Financial Model:',
    ForBusinessCase:
      "For Business Case, Please Click on 'View Business case template' to fill all the required fields and attach a copy of the file.",

    ForFinancialModel:
      "For Financial model, Please Click on 'View Financial model template' to fill all the required fields and attach a copy of the file.",
    AttachDocumentsNewRequest:
      'Attach documents as required for Business Case, Financial Model, Field/BG Business Approval, Field/BG Finance Approval, Exception Approvals, Terms and Conditions – Draft, List of Eligible Partner IDs',
    AttachDocumentsChangeRequest:
      'Attach documents as required for Financial Model, Terms and Conditions, Amendment or Business Letter - Draft, List of Eligible Partner IDs, Finance Approval (if available), CELA Approval (if available), Compliance Approval (if available), Operation Approval (if available), Corp Accounting Approval (if available) ',
    NoAttachments: 'No attachments',
    GPSPolicyDeclareMandatory: 'Policy Declaration mandatory',
    GPSDeclarePolicy:
      'I have reviewed the following policies and agree to adhere to the required process',
  },
  GPSMultiplePartners: 'You can add multiple partners. A maximum of 30 partners can be added',
  OngoingMonitoring: {
    ControlCategory: 'Category',
    ControlState: 'State',
    ControlType: 'Type',
    DPSControlType: 'Control Type',
    ControlOwner: 'Accepted By',
    ControlOwnerName: 'Control Owner Name',
    ControlActivity: 'Control Activity',
    ControlFrequency: 'Control Frequency',
    ControlActivitiesDocumentation: 'Control Activities documentation',
    Documentation: 'Documentation',
    ControlStartDate: 'Control Start Date',
    ControlEndDate: 'Control End Date',
  },
};
export const CaseIDqueryId = {
  queryId: '90907bd1-cb52-4efa-b6ce-98284e3f7989',
};
const BASE_URL =
  'https://microsoft.sharepoint.com/teams/PartnerInvestmentFramework/PartnerInvestmentcouncil/Shared%20Documents/Forms';

export const GPSInvBusinessTemplatePath = `${BASE_URL}/AllItems.aspx?id=%2Fteams%2FPartnerInvestmentFramework%2FPartnerInvestmentcouncil%2FShared%20Documents%2F05%2E%20PIR%2FPIR%20Business%20Case%20Templates&p=true&ga=1&OR=Teams%2DHL&CT=1706828814014&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyNy8yNDAxMDQxNzUwMyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D`;
export const GPSInvFinancialTemplatePath = `${BASE_URL}/AllItems.aspx?id=%2Fteams%2FPartnerInvestmentFramework%2FPartnerInvestmentcouncil%2FShared%20Documents%2F05%2E%20PIR%2FPIR%20Financial%20Templates&p=true&ga=1&OR=Teams%2DHL&CT=1706828852352&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyNy8yNDAxMDQxNzUwMyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D`;
export const GPSInvCommercialTemplatePath = `${BASE_URL}/AllItems.aspx?id=%2Fteams%2FPartnerInvestmentFramework%2FPartnerInvestmentcouncil%2FShared%20Documents%2F16%2E%20Commercial%20Governance%2FCommercial%20Governance%20Framework%2Epdf&parent=%2Fteams%2FPartnerInvestmentFramework%2FPartnerInvestmentcouncil%2FShared%20Documents%2F16%2E%20Commercial%20Governance&p=true&ct=1715964020898&or=Teams%2DHL&ga=1`;
export const GPSInvDPSTemplatePath = `${BASE_URL}/AllItems.aspx?id=%2Fteams%2FPartnerInvestmentFramework%2FPartnerInvestmentcouncil%2FShared%20Documents%2F14%2E%20DPS%20Governance%2FDPS%20Governance%20Framework%2Epdf&parent=%2Fteams%2FPartnerInvestmentFramework%2FPartnerInvestmentcouncil%2FShared%20Documents%2F14%2E%20DPS%20Governance&p=true&ga=1`;

// Generated by GitHub Copilot | Updated on: 2026-06-19 | 1 lines modified | Added ValidateSRNumbers API endpoint constant
// Generated by GitHub Copilot | Updated on: 2026-07-23 | 1 line modified | Added FactoryRecommendedSplitDetails dummy endpoint URL constant
// Generated by GitHub Copilot | Updated on: 2026-08-26 | 4 lines modified | Removed top-level survey questions accordion
// Generated by GitHub Copilot | Updated on: 2026-09-16 | 1 line modified | Added current Triage Owner field key
